import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import logoImg from '../../assets/img/logo.svg';
import ProgressBar from './ProgressBar';

export default function Header() {

    return (
        <Box as="header" sx={{
            position: 'fixed',
            top: 0,
            width: '100vw',
            height: '111px',
            backgroundColor: '#dee8f1',
            display: 'flex',
            justifyContent: 'center',
            color: 'white',
            zIndex: 100
        }}>
            <Container maxWidth="md" sx={{ display: 'flex' }}>
                <img src={logoImg} width="189" height="69" style={{ marginTop: '20px' }} />
                <ProgressBar />
            </Container>
        </Box>
    )
}
